import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const People = ({ size = 20, color = colors('neutral', 3) }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7662 9.84796C15.3946 9.84796 16.7148 8.53885 16.7148 6.92398C16.7148 5.30911 15.3946 4 13.7662 4C12.1377 4 10.8176 5.30911 10.8176 6.92398C10.8176 8.53885 12.1377 9.84796 13.7662 9.84796Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M19 16.9977V15.9494C19 13.6367 17.1085 11.761 14.7764 11.761H12.756C10.4238 11.761 8.53232 13.6367 8.53232 15.9494V16.9977"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6.40878 10.9241C7.78092 10.9241 8.89327 9.82099 8.89327 8.46029C8.89327 7.09959 7.78092 5.99652 6.40878 5.99652C5.03663 5.99652 3.92429 7.09959 3.92429 8.46029C3.92429 9.82099 5.03663 10.9241 6.40878 10.9241Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6.88885 12.5908H5.55798C3.59148 12.5908 2 14.1713 2 16.1191V17"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default People;
